<p class="modal-title">Price History: {{ itemName() }}</p>
<div class="body">
  @if (isLoading()) {
    <div class="loading-container">
      <app-loading-icon [color]="'var(--yellow)'" [size]="'32px'" />
      <span class="loading-text">Loading history...</span>
    </div>
  } @else {
    <div class="history-table">
      <div class="history-header">
        <span class="col-date">Date</span>
        <span class="col-price">Price</span>
        <span class="col-change">Change</span>
        <span class="col-admin">Admin</span>
      </div>
      @for (entry of history(); track entry.date) {
        <div class="history-row">
          <span class="col-date">
            {{ entry.date * 1000 | date : 'yyyy.MM.dd HH:mm:ss' }}
          </span>
          <span class="col-price">
            {{ entry.price | currency : 'USD' : 'symbol' : '1.2-2' }}
          </span>
          <span class="col-change">
            {{ entry.previous_price | currency : 'USD' : 'symbol' : '1.2-2' }}
            →
            {{ entry.price | currency : 'USD' : 'symbol' : '1.2-2' }}
            <span class="change-indicator" [class]="getChangeClass(entry)">
              <svg-icon class="change-arrow" [src]="getChangeIcon(entry)" /> {{ getChangePercent(entry) | number : '1.2-2' }}%
            </span>
          </span>
          <span class="col-admin">
            @if (entry.admin.avatar) {
              <img
                class="avatar"
                [src]="entry.admin.avatar"
                [appTooltip]="entry.admin.name"
                alt=""
              />
            }
          </span>
        </div>
      }
      @if (history().length === 0) {
        <div class="history-row empty">No price history available</div>
      }
    </div>
  }
</div>
